<template>
  <div class="popup-down-payment">
    <b-modal
      id="popup-down-payment"
      ref="popup-down-payment"
      hide-footer
      :titleHtml="modalTitle"
      size="md"
    >
      <b-row>
        <b-col md="12">
          <b-form-group class="required-control">
            <label>Số tiền: </label>
            <b-row>
              <b-col class="pr-0" cols="5">
                <b-form-select
                  class="select-style"
                  v-model="mainModel.paymentType"
                  :options="listPaymentType"
                  size="sm"
                  value-field="id"
                  text-field="name"
                  :disabled="lockPaymentType"
                  @change="fetchAccountants()"
                >
                </b-form-select>
              </b-col>
              <b-col class="pl-0" cols="7">
                <b-form-input
                  ref="amountInput"
                  class="input-style text-right"
                  size="sm"
                  type="text"
                  v-model="mainModel.amount"
                  placeholder="Nhập số tiền"
                  v-mask="currency"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group v-if="mainModel.contractId">
            <label>Đợt thanh toán (gắn phiếu vào đợt nào): </label>
            <b-form-select
              v-if="listPaymentTerms.length > 1"
              class="select-style"
              v-model="mainModel.paymentTermId"
              :options="listPaymentTerms"
              size="sm"
              @change="onPaymentTermChange"
            ></b-form-select>
            <div v-else class="text-muted small">
              <i class="fas fa-info-circle mr-1"></i>Hợp đồng chưa có đợt thanh
              toán nào — phiếu thu sẽ ghi nhận chung cho hợp đồng.
            </div>
          </b-form-group>
          <b-form-group class="required-control">
            <label>Chọn tài khoản: </label>
            <Autosuggest
              :model="mainModel.accountantName"
              :suggestions="listAccountants"
              :placeholder="placeHolderAccountant"
              :limit="10"
              @select="onSelect($event, 'Accountants')"
              @change="onInputChangeAccountants"
              errorMessages="Yêu cầu chọn tài khoản."
              suggestionName="text"
            />
          </b-form-group>
          <b-form-group v-if="mainModel.paymentType === PAYMENT_TYPE.TRANSFER">
            <label>Nhập mã tham chiếu (có thể bỏ trống): </label>
            <b-form-input
              class="input-style"
              size="sm"
              type="text"
              v-model="mainModel.paymentCode"
              placeholder="Nhập mã tham chiếu"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            class="required-control"
            v-if="mainModel.paymentType === PAYMENT_TYPE.CREDIT"
          >
            <label>Nhập 4 số cuối của mã thẻ: </label>
            <b-form-input
              class="input-style"
              size="sm"
              type="text"
              v-model="mainModel.creditCardNo"
              placeholder="Nhập 4 số cuối của mã thẻ"
            ></b-form-input>
          </b-form-group>
          <b-form-group :label="'Chứng từ'">
            <b-row>
              <b-col class="pr-0" cols="5">
                <b-form-select
                  class="select-style"
                  v-model="mainModel.entityType"
                  :options="listEntityType"
                  size="sm"
                  value-field="id"
                  text-field="name"
                  :disabled="true"
                >
                </b-form-select>
              </b-col>
              <b-col class="pl-0" cols="7">
                <b-form-input
                  class="input-style text-right"
                  size="sm"
                  type="text"
                  :value="mainModel.contractNumber || mainModel.entityId"
                  placeholder="Mã chứng từ"
                  :disabled="true"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group
            :label="'Diễn giải'"
            v-if="mainModel.paymentType !== PAYMENT_TYPE.CREDIT"
          >
            <b-row>
              <b-col class="pr-0" cols="12">
                <b-form-textarea
                  size="sm"
                  id="input-note"
                  class="input-style"
                  v-model="mainModel.note"
                  :placeholder="'Thêm ghi chú'"
                  :rows="5"
                  :max-rows="10"
                ></b-form-textarea>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group :label="'Hình ảnh đính kèm'">
            <input
              ref="paymentImageInput"
              type="file"
              accept="image/*"
              multiple
              class="d-none"
              @change="onSelectImages"
            />
            <b-button
              size="sm"
              variant="outline-primary"
              class="dp-upload-btn"
              :disabled="uploadingImage"
              @click="$refs.paymentImageInput.click()"
            >
              <i class="fas fa-camera mr-1"></i>
              {{ uploadingImage ? 'Đang tải...' : 'Tải ảnh lên' }}
            </b-button>
            <div
              v-if="mainModel.images && mainModel.images.length"
              class="dp-image-list mt-2"
            >
              <div
                v-for="(img, idx) in mainModel.images"
                :key="idx"
                class="dp-image-item"
              >
                <img
                  :src="img.preview"
                  alt="payment-image"
                  style="cursor: zoom-in"
                  @click="openLightbox(idx)"
                />
                <span
                  class="dp-image-remove"
                  title="Xóa ảnh"
                  @click="removeImage(idx)"
                >
                  <i class="fas fa-times"></i>
                </span>
              </div>
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-button
        style="fontweight: 600; width: 70px"
        variant="primary"
        size="sm"
        :disabled="uploadingImage"
        @click="onSubmit"
        >Lưu</b-button
      >
      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="hideModal"
        >Hủy</b-button
      >
    </b-modal>

    <vue-easy-lightbox
      escDisabled
      :visible="lightbox.visible"
      :imgs="lightbox.imgs"
      :index="lightbox.index"
      @hide="lightbox.visible = false"
    />
  </div>
</template>

<script>
import timeUtils from '@/utils/date';
import ApiService from '@/core/services/api.service';
import { DOC_TYPE, CONTACT_TYPE } from '@/utils/constants';
import { CONTACT_TYPE as CONTACT_TYPE_ENUM, PAYMENT_TYPE } from '@/utils/enum';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import { ACCOUNTANT_TYPE } from '@/utils/enum';
import VueEasyLightbox from 'vue-easy-lightbox';
import _ from 'lodash';
import {
  makeToastFaile,
  makeToastSuccess,
  currencyMask,
  xoa_dau,
  unMaskPrice,
  convertPrice,
} from '@/utils/common';

export default {
  components: {
    Autosuggest,
    VueEasyLightbox,
  },
  data() {
    return {
      currency: currencyMask,
      DOC_TYPE,
      CONTACT_TYPE,
      CONTACT_TYPE_ENUM,
      PAYMENT_TYPE,
      listType: [],
      listTypeOld: [],
      listEntityType: [],
      listContactTypes: [],
      listAccountants: [],
      optionAccountants: [],
      listAccountantRefs: [],
      optionAccountantsRef: [],
      listPaymentType: [
        { id: 'CASH', name: 'Tiền mặt' },
        { id: 'TRANSFER', name: 'Chuyển khoản' },
        { id: 'CREDIT', name: 'Quẹt thẻ' },
      ],
      // Options chọn đợt thanh toán của HĐ để gắn phiếu thu
      listPaymentTerms: [],
      dpConfigs: timeUtils.DP_CONFIG,
      editable: true,
      selectedStoreId: null,
      modalTitle: null,
      lockPaymentType: false,
      // Lightbox phóng to ảnh đã chọn.
      lightbox: { visible: false, imgs: [], index: 0 },
      mainModel: {},
      defaultMainModel: {
        id: null,
        code: '',
        paymentDate: new Date(),
        paymentCode: null,
        creditCardNo: null,
        entityType: 3,
        type: null,
        amount: 0,
        vatAmount: 0,
        contactType: null,
        accountantId: null,
        accountantName: null,
        accountantRefName: null,
        accountantRefId: null,
        customerId: null,
        entityId: null,
        contractNumber: null,
        paymentType: 'CASH',
        storeId: null,
        contractId: null,
        paymentTermId: null,
        note: null,
        images: [],
      },
      uploadingImage: false,
    };
  },
  created() {},
  //   mounted() {
  //     this.fetchAccountants();
  //   },
  computed: {
    placeHolderAccountant: function () {
      const mode = this.$route.params.mode;
      return mode === 'cash' ? 'tài khoản tiền mặt' : 'tài khoản ngân hàng';
    },
  },
  methods: {
    onSubmit() {
      if (!this.mainModel.amount || this.mainModel.amount <= 0) {
        makeToastFaile('Số tiền phải lớn hơn hoặc bằng 0');
        return;
      }
      if (!this.mainModel.accountantId) {
        makeToastFaile('Vui lòng chọn tài khoản ngân hàng');
        return;
      }
      // Mã tham chiếu (paymentCode) KHÔNG còn bắt buộc khi báo có (TRANSFER) —
      // cho phép lưu thiếu; HĐ thiếu mã sẽ được cảnh báo + filter ở danh sách
      // và alert ở chi tiết HĐ.

      if (
        (this.mainModel.paymentType === PAYMENT_TYPE.CREDIT &&
          !this.mainModel.creditCardNo) ||
        (this.mainModel.creditCardNo && this.mainModel.creditCardNo.length > 4)
      ) {
        makeToastFaile('Vui lòng nhập 4 số cuối của mã thẻ');
        return;
      }

      if (!this.mainModel.entityId) {
        makeToastFaile('Chứng từ không được để trống !!');
        return;
      }
      const data = {
        accountId: this.mainModel.accountantId,
        paymentType: this.mainModel.paymentType,
        paymentCode: this.mainModel.paymentCode,
        creditCardNo: this.mainModel.creditCardNo,
        amount: unMaskPrice(this.mainModel.amount),
        contractId: this.mainModel.contractId,
        paymentTermId: this.mainModel.paymentTermId || null,
        note: this.mainModel.note || null,
        images:
          this.mainModel.images && this.mainModel.images.length
            ? this.mainModel.images.map((i) => i.url)
            : null,
      };
      ApiService.post('contract/payment', data)
        .then(() => {
          makeToastSuccess(
            this.mainModel.paymentType === PAYMENT_TYPE.TRANSFER
              ? 'Tạo phiếu báo có thành công!!'
              : 'Tạo phiếu thu thành công!!',
          );
          this.$emit('fetchContract');
          this.hideModal();
          return;
        })
        .catch(({ response }) => {
          this.onSubmiting = false;
          makeToastFaile(response.$error);
        });
    },
    async onSelectImages(event) {
      const files = Array.from(
        (event && event.target && event.target.files) || [],
      );
      if (!files.length) return;
      this.uploadingImage = true;
      try {
        for (const file of files) {
          if (!file.type || !file.type.startsWith('image/')) {
            makeToastFaile('Chỉ cho phép tải lên hình ảnh');
            continue;
          }
          // Preview hiển thị ngay bằng blob local — vì ảnh upload là file PRIVATE
          // trên Minio (server trả về object path, KHÔNG render trực tiếp qua <img src>).
          const preview = URL.createObjectURL(file);
          const formData = new FormData();
          formData.append('file', file);
          formData.append('folder', 'contracts');
          try {
            const res = await ApiService.post('files/upload', formData);
            const body = (res && res.data) || {};
            const inner = body.data || body; // hỗ trợ cả response bọc { data } lẫn raw
            const url = inner && inner.url;
            if (url) {
              // url = object path private (lưu để gắn vào phiếu); preview = blob hiển thị.
              this.mainModel.images.push({ url, preview });
            } else {
              URL.revokeObjectURL(preview);
              makeToastFaile('Không lấy được đường dẫn ảnh sau khi tải lên');
            }
          } catch (e) {
            URL.revokeObjectURL(preview);
            throw e;
          }
        }
      } catch (err) {
        makeToastFaile(
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
            'Tải ảnh lên thất bại',
        );
      } finally {
        this.uploadingImage = false;
        if (event && event.target) event.target.value = '';
      }
    },
    removeImage(idx) {
      const removed = this.mainModel.images.splice(idx, 1)[0];
      if (removed && removed.preview) {
        URL.revokeObjectURL(removed.preview);
      }
    },
    openLightbox(idx) {
      this.lightbox = {
        visible: true,
        imgs: (this.mainModel.images || []).map((i) => i.preview),
        index: idx,
      };
    },
    onSelect(suggestion, type) {
      switch (type) {
        case 'Accountants': {
          this.mainModel.accountantId = suggestion.item.value;
          this.mainModel.accountantName = suggestion.item.text;
          break;
        }
        case 'AccountantRefs': {
          this.mainModel.accountantRefId = suggestion.item.value;
          this.mainModel.accountantRefName = suggestion.item.text;
          break;
        }
      }
    },
    fetchAccountants: async function () {
      this.listAccountants = [];
      this.optionAccountants = [];
      this.mainModel.accountantName = null;
      this.mainModel.accountantId = null;

      let params = {
        type: ACCOUNTANT_TYPE.CASH, // mặc định sẽ fetch tài khoản tiền mặt
      };

      // 2 là chuyển khoản
      if (this.mainModel.paymentType === PAYMENT_TYPE.TRANSFER) {
        params['type'] = ACCOUNTANT_TYPE.TRANSFER;
      }
      // 3 là quẹt thẻ
      if (this.mainModel.paymentType === PAYMENT_TYPE.CREDIT) {
        params['type'] = ACCOUNTANT_TYPE.CREDIT;
      }
      let url = 'accountants/getByType';

      if (
        this.selectedStoreId !== null &&
        this.mainModel.paymentType === PAYMENT_TYPE.CASH
      ) {
        params.storeId = this.selectedStoreId;
        url = 'accountants/getByStore';
      }
      ApiService.query(url, {
        params,
      }).then((response) => {
        const data = response.data.data || [];

        _.map(data, (item) => {
          this.listAccountants.push({
            value: item.id,
            text: item.name,
          });
        });
        this.optionAccountants = [...this.listAccountants];

        // Tự chọn tài khoản: nếu chỉ có 1, hoặc đang ở chế độ "thêm phiếu nhanh"
        // từ điều khoản thanh toán (loại phiếu đã bị khóa) → lấy tài khoản đầu tiên.
        if (
          this.listAccountants.length === 1 ||
          (this.lockPaymentType && this.listAccountants.length)
        ) {
          this.mainModel.accountantId = this.listAccountants[0].value;
          this.mainModel.accountantName = this.listAccountants[0].text;
        }
      });
    },
    fetchAllAccountants: async function () {
      this.listAccountantRefs = [];
      this.optionAccountantsRef = [];
      this.mainModel.accountantRefName = null;
      this.mainModel.accountantRefId = null;

      ApiService.query('accountants', { getFull: true }).then((response) => {
        const data = response.data.data || [];
        _.map(data, (item) => {
          this.listAccountantRefs.push({
            value: item.id,
            text: item.name,
            code: item.code,
          });
        });
        this.optionAccountantsRef = [...this.listAccountantRefs];
      });
    },
    onInputChangeAccountants(text) {
      // if (!text) {
      //   text = '';
      //   this.mainModel.accountantName.$touch();
      // }
      this.mainModel.accountantName = text;
      const filteredData = this.optionAccountants
        .filter((item) => {
          const nameNoneSign = xoa_dau(item.text).trim();
          const searchTermNoneSign = xoa_dau(text).trim();
          return (
            nameNoneSign.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
            nameNoneSign
              .toLowerCase()
              .indexOf(searchTermNoneSign.toLowerCase()) > -1
          );
        })
        .slice(0, 10);

      this.listAccountants = [...filteredData];
    },
    showModal({
      entityId = null,
      selectedStoreId = null,
      contractId,
      contractNumber = null,
      paymentTermId = null,
      paymentTerms = null,
      payments = null,
      paymentType = null,
      amount = null,
    }) {
      this.mainModel = Object.assign({}, this.defaultMainModel);
      // Object.assign shallow → cấp mảng images mới để không dùng chung ref giữa các lần mở.
      this.mainModel.images = [];
      this.uploadingImage = false;
      if (entityId) {
        this.mainModel.entityId = entityId;
      }
      if (selectedStoreId) {
        this.selectedStoreId = selectedStoreId;
      }

      if (contractId) {
        this.mainModel.contractId = contractId;
      }
      this.mainModel.contractNumber = contractNumber || null;
      this.mainModel.paymentTermId = paymentTermId || null;
      // Điền sẵn số tiền (gợi ý từ điều khoản thanh toán — số còn lại của đợt).
      if (amount !== null && amount !== undefined && Number(amount) > 0) {
        this.mainModel.amount = Number(amount);
      }
      // Khi mở từ 1 đợt thanh toán cụ thể: ép loại phiếu (CASH = phiếu thu, TRANSFER = phiếu báo có).
      this.lockPaymentType = !!paymentType;
      if (paymentType) {
        this.mainModel.paymentType = paymentType;
      }
      const docLabel =
        this.mainModel.paymentType === PAYMENT_TYPE.TRANSFER
          ? 'phiếu báo có'
          : 'phiếu thu';
      const docCode = this.mainModel.contractNumber || this.mainModel.entityId;
      this.modalTitle = `<div>
              <span class='d-block' style='font-size: 1.1rem'> Tạo ${docLabel} cho HĐ: <a class='text-primary'>${docCode}</a></span>
              </div>`;

      // Danh sách đợt thanh toán: nếu caller truyền sẵn → dùng luôn; nếu chỉ có contractId → fetch HĐ.
      this.listPaymentTerms = [];
      if (Array.isArray(paymentTerms) && paymentTerms.length) {
        this.setPaymentTermOptions(paymentTerms, payments || null);
      } else if (contractId) {
        ApiService.query(`contract/${contractId}`)
          .then((res) => {
            const c = (res && res.data && res.data.data) || {};
            this.setPaymentTermOptions(
              c.contractPaymentTerm || [],
              c.payments || [],
            );
            // Nếu chưa chọn đợt + chưa có số tiền → gợi ý theo đợt được chọn (nếu có sẵn).
            if (this.mainModel.paymentTermId) this.onPaymentTermChange();
          })
          .catch(() => {});
      }

      this.fetchAccountants();
      this.fetchAllAccountants();
      this.mapDateEnum();
      this.fetchTransactionCategory();

      this.$refs['popup-down-payment'].show();
    },
    /** Build options cho dropdown "Đợt thanh toán" + tính số còn lại của từng đợt. */
    setPaymentTermOptions(terms, payments) {
      const opts = [{ value: null, text: '— Không gắn vào đợt nào —' }];
      (terms || []).forEach((t, i) => {
        const paid = (payments || [])
          .filter((p) => p.paymentTermId === t.id)
          .reduce((s, p) => s + Number(p.amount || 0), 0);
        const total = Number(unMaskPrice(t.totalAmount) || 0);
        const remaining = Math.max(0, total - paid);
        const name = (t.name || '').toString().trim() || `Đợt ${i + 1}`;
        opts.push({
          value: t.id,
          text:
            `${name} — ` +
            (payments
              ? `Còn lại: ${convertPrice(remaining)} / ${convertPrice(total)}`
              : `Số tiền: ${convertPrice(total)}`),
          _remaining: payments ? remaining : total,
        });
      });
      this.listPaymentTerms = opts;
    },
    onPaymentTermChange(val) {
      // BootstrapVue truyền value mới qua @change; v-model cũng đã cập nhật.
      const termId = val !== undefined ? val : this.mainModel.paymentTermId;
      this.mainModel.paymentTermId = termId;
      const opt = this.listPaymentTerms.find((o) => o.value === termId);
      if (opt && Number(opt._remaining) > 0) {
        this.setAmount(opt._remaining);
      }
    },
    /**
     * Gán số tiền cho ô input có v-mask. Đặt model + ép input dispatch sự kiện `input`
     * để vue-the-mask format lại (mask không tự cập nhật khi model đổi bằng code).
     */
    setAmount(value) {
      this.mainModel.amount = Number(value);
      this.$nextTick(() => {
        const ref = this.$refs.amountInput;
        const el = ref && (ref.$el || ref);
        if (el && typeof el.dispatchEvent === 'function') {
          el.value = String(value);
          el.dispatchEvent(new Event('input', { bubbles: true }));
        }
      });
    },
    fetchTransactionCategory: function () {
      const params = { getFull: true, type: 1 };
      ApiService.query('transaction-categories', { params }).then(
        (response) => {
          const data = response.data.data || null;
          if (data) {
            this.listType = data.data;
            let list = this.recursionChildType(data.data, []);
            this.listTypeOld = list;
            this.listType = list;
          }
        },
      );
    },
    recursionChildType: function (items, listData = []) {
      let level0 = items.filter((x) => x.level === 0);
      if (level0.length > 0) {
        for (const item of level0) {
          listData.push({
            html: `${item.name}`,
            value: item.id,
            disabled: true,
            ...item,
          });
          let childs = this.listType.filter((x) => x.parentId === item.id);

          if (childs.length > 0) {
            this.recursionChildType(childs, listData);
          }
        }
      } else {
        for (const item of items) {
          listData.push({
            html: `<p>${this.genLevel(item.level)} ${item.name}</p>`,
            value: item.id,
            ...item,
          });
          let childs = this.listType.filter((x) => x.parentId === item.id);
          if (childs.length > 0) {
            this.recursionChildType(childs, listData);
          }
        }
      }
      return listData;
    },
    genLevel: function (level) {
      let str = '';
      if (level) {
        for (let i = 0; i < level; i++) {
          str += ' - ';
        }
      }
      return str;
    },
    hideModal() {
      this.$refs['popup-down-payment'].hide();
    },
    mapDateEnum() {
      this.listEntityType = this.DOC_TYPE.map((item) => ({
        id: item.value,
        name: item.text,
      }));
      this.listContactTypes = this.CONTACT_TYPE.map((item) => ({
        id: item.value,
        name: item.text,
      }));
    },
  },
};
</script>

<style scoped lang="scss">
// Icon trong nút tải ảnh kế thừa màu nút (frontend-styling rule #1).
.dp-upload-btn i {
  color: inherit !important;
}
.dp-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.dp-image-item {
  position: relative;
  width: 72px;
  height: 72px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .dp-image-remove {
    position: absolute;
    top: 2px;
    right: 2px;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(15, 23, 42, 0.6);
    color: #fff;
    border-radius: 50%;
    cursor: pointer;
    font-size: 10px;
    i {
      color: inherit !important;
    }
  }
}
</style>
